import { PlacedImage } from "./PlacedImage";
import { FULL_BOX, VIEW } from "../../lib/shield";

const R = (props) => <rect x="0" y="0" width="400" height="560" {...props} />;
const Stretch = ({ children }) => <g transform={`scale(1 ${VIEW.h / 560})`}>{children}</g>;

const Stripes = ({ p, s, diagonal }) => (
  <>
    <R fill={s} />
    <g transform={diagonal ? "rotate(-32 200 280)" : undefined}>
      {Array.from({ length: diagonal ? 18 : 5 }, (_, i) => (
        <rect key={i} x={(diagonal ? -400 : 0) + i * 88} y={diagonal ? -400 : 0} width="44" height={diagonal ? 1400 : 560} fill={p} />
      ))}
    </g>
  </>
);

const Split = ({ p, s, diagonal }) =>
  diagonal ? (
    <><polygon points="0,0 400,0 0,560" fill={p} /><polygon points="400,0 400,560 0,560" fill={s} /></>
  ) : (
    <><rect width="200" height="560" fill={p} /><rect x="200" width="200" height="560" fill={s} /></>
  );

const Geometric = ({ p, s, a }) => (
  <>
    <R fill={p} />
    <polygon points="0,0 400,0 400,90 0,250" fill="#000" opacity=".18" />
    <polygon points="260,0 400,0 400,210" fill={s} opacity=".85" />
    <polygon points="330,0 400,0 400,70" fill={a} />
    <polygon points="400,130 400,380 250,560 150,560" fill={s} opacity=".22" />
    <polygon points="0,300 170,560 0,560" fill={a} opacity=".75" />
    <polygon points="0,360 110,560 0,560" fill={s} opacity=".35" />
    <polyline points="0,250 400,90" stroke={a} strokeWidth="3" fill="none" />
    <polyline points="0,272 400,112" stroke={s} strokeWidth="1.2" fill="none" opacity=".6" />
  </>
);

const Abstract = ({ p, s, a, uid }) => (
  <>
    <defs>
      <radialGradient id={`${uid}-glow`} cx="0.72" cy="0.28" r="0.6">
        <stop offset="0" stopColor={s} stopOpacity=".55" />
        <stop offset="1" stopColor={s} stopOpacity="0" />
      </radialGradient>
      <linearGradient id={`${uid}-shade`} x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#000" stopOpacity="0" />
        <stop offset="1" stopColor="#000" stopOpacity=".35" />
      </linearGradient>
    </defs>
    <R fill={p} />
    <R fill={`url(#${uid}-glow)`} />
    <path d="M-20,380 C80,300 220,420 420,250 L420,300 C240,460 100,350 -20,440 Z" fill={s} opacity=".22" />
    <path d="M-20,110 C120,40 250,210 420,60 L420,20 C260,150 120,0 -20,70 Z" fill={a} opacity=".35" />
    <path d="M-20,190 C120,120 230,260 420,120" stroke={a} strokeWidth="6" fill="none" opacity=".85" />
    <path d="M-20,232 C130,152 240,302 420,162" stroke={s} strokeWidth="2" fill="none" opacity=".6" />
    <path d="M-20,300 C140,210 260,380 420,220" stroke={a} strokeWidth="1.5" fill="none" opacity=".5" />
    <R fill={`url(#${uid}-shade)`} />
  </>
);

const Gradient = ({ p, s, uid }) => (
  <>
    <defs>
      <linearGradient id={`${uid}-grad`} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor={p} />
        <stop offset="1" stopColor={s} />
      </linearGradient>
    </defs>
    <R fill={`url(#${uid}-grad)`} />
  </>
);

export const BackgroundLayer = ({ background, colours, uid, uploadHref }) => {
  const { primary: p, secondary: s, accent: a } = colours;
  const diagonal = background.variant === "diagonal";
  if (background.style === "upload") {
    const o = background.overlay;
    return (
      <>
        <rect width={VIEW.w} height={VIEW.h} fill={p} />
        <PlacedImage placement={background.upload} box={FULL_BOX} href={uploadHref} />
        {o.enabled && <rect width={VIEW.w} height={VIEW.h} fill={o.color} opacity={o.opacity} />}
      </>
    );
  }
  const body = {
    solid: <R fill={p} />,
    gradient: <Gradient p={p} s={s} uid={uid} />,
    stripes: <Stripes p={p} s={s} diagonal={diagonal} />,
    split: <Split p={p} s={s} diagonal={diagonal} />,
    geometric: <Geometric p={p} s={s} a={a} />,
  }[background.style] || <Abstract p={p} s={s} a={a} uid={uid} />;
  return <Stretch>{body}</Stretch>;
};
